import { Box, Skeleton, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { WEEK_DAY_COUNT } from "../../weekMenuTypes"

const DISH_ROW_COUNT = 3

const useStyles = makeStyles()((theme) => ({
    scrollArea: {
        width: 0,
        minWidth: "100%",
        overflow: "hidden",
        border: `1px solid ${theme.palette.tailwind.gray[200]}`,
        borderRadius: ".625rem",
        background: theme.palette.background.paper,
    },
    table: {
        display: "grid",
        gridTemplateColumns: "15rem repeat(7, minmax(14.5rem, 1fr))",
    },
    headCell: {
        padding: ".625rem .75rem",
        background: theme.palette.tailwind.gray[50],
        borderLeft: `1px solid ${theme.palette.tailwind.gray[200]}`,
        borderBottom: `1px solid ${theme.palette.tailwind.gray[200]}`,
    },
    corner: {
        background: theme.palette.tailwind.gray[50],
        borderBottom: `1px solid ${theme.palette.tailwind.gray[200]}`,
    },
    categoryRow: {
        gridColumn: "1 / -1",
        padding: ".625rem 1rem",
        background: theme.palette.tailwind.slate[100],
        borderBottom: `1px solid ${theme.palette.tailwind.gray[200]}`,
    },
    labelCell: {
        padding: ".875rem",
        background: theme.palette.tailwind.gray[50],
        borderBottom: `1px solid ${theme.palette.tailwind.gray[200]}`,
    },
    cell: {
        minHeight: "9rem",
        padding: ".625rem .625rem .75rem",
        borderLeft: `1px solid ${theme.palette.tailwind.gray[200]}`,
        borderBottom: `1px solid ${theme.palette.tailwind.gray[200]}`,
    },
    chip: {
        borderRadius: ".25rem",
    },
    pill: {
        borderRadius: "62.5rem",
    },
    rowGroup: {
        display: "contents",
    },
}))

/** Lightweight stand-in with the table's real layout, shown while the heavy grid mounts. */
export function WeekMenuTableSkeleton() {
    const { classes } = useStyles()

    const dayIndexes = Array.from({ length: WEEK_DAY_COUNT }, (_, dayIndex) => dayIndex)
    const rowIndexes = Array.from({ length: DISH_ROW_COUNT }, (_, rowIndex) => rowIndex)

    return (
        <Box className={classes.scrollArea}>
            <Box className={classes.table}>
                <Box className={classes.corner} />
                {dayIndexes.map((dayIndex) => (
                    <Stack key={`head-${dayIndex}`} alignItems="center" spacing=".125rem" className={classes.headCell}>
                        <Skeleton variant="text" width="2.5rem" height="1.125rem" />
                        <Skeleton variant="text" width="3.5rem" height="1.125rem" />
                        {/* Publish switch, its status label and the filled-count badge. */}
                        <Stack direction="row" alignItems="center" spacing=".375rem">
                            <Skeleton variant="rounded" width="1.75rem" height="1rem" className={classes.pill} />
                            <Skeleton variant="text" width="3rem" height="1rem" />
                            <Skeleton variant="rounded" width="2rem" height="1.25rem" className={classes.pill} />
                        </Stack>
                    </Stack>
                ))}
                <Box className={classes.categoryRow}>
                    <Skeleton variant="text" width="10rem" height="1.25rem" />
                </Box>
                {rowIndexes.map((rowIndex) => (
                    <Box key={`row-${rowIndex}`} className={classes.rowGroup}>
                        <Stack spacing=".75rem" className={classes.labelCell}>
                            <Skeleton variant="text" width="60%" height="1.375rem" />
                            <Skeleton variant="text" width="4rem" height="1rem" />
                            <Skeleton variant="rounded" width="5.5rem" height="1.25rem" className={classes.chip} />
                        </Stack>
                        {dayIndexes.map((dayIndex) => (
                            <Stack key={`cell-${rowIndex}-${dayIndex}`} spacing=".5rem" className={classes.cell}>
                                <Skeleton variant="text" width="70%" height="1.25rem" />
                                <Skeleton variant="text" width="90%" height="1.125rem" />
                                <Skeleton variant="text" width="55%" height="1.125rem" />
                                <Skeleton variant="rounded" width="4rem" height="1.125rem" className={classes.chip} />
                            </Stack>
                        ))}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
